// @ts-nocheck
import { DownOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import Button from 'antd/lib/button';
import React, { useCallback } from 'react';
import { driverApi } from '../../../lib/api';
import { printNotification } from '../../../lib/notificationWrapper';
export default props => {
  const printDriverStats = useCallback(async () => {
    printNotification(async () => {
      await driverApi.printDriverStats(props.driverId);
    });
  }, [props.driverId]);
  const printTestsHistory = useCallback(async () => {
    printNotification(async () => {
      await driverApi.printTestsHistory(props.driverId);
    });
  }, [props.driverId]);
  const handleMenuClick = useCallback(async ({
    key
  }) => {
    switch (key) {
      case 'printDriverStats':
        await printDriverStats();
        break;
      case 'printTestsHistory':
        await printTestsHistory();
        break;
      default:
        break;
    }
  }, [printDriverStats, printTestsHistory]);
  const menuItems = [{
    key: 'printDriverStats',
    label: 'Результаты тестирований по темам ПДД'
  }, {
    key: 'printTestsHistory',
    label: 'История тестирований'
  }];
  return <>
      <Dropdown menu={{
        items: menuItems,
        onClick: handleMenuClick
      }}>
        <Button>
          Печать
          <DownOutlined />
        </Button>
      </Dropdown>
    </>;
};
